// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取模拟实盘体验券信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-coupon/info */
export async function strategyCouponInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyCouponInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyCouponResp>('/strategy-coupon/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取模拟实盘体验券列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-coupon/list */
export async function strategyCouponListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyCouponListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategyCouponResp>('/strategy-coupon/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取已使用体验券列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-coupon/used/list */
export async function strategyCouponUsedListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyCouponUsedListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategyCouponResp>('/strategy-coupon/used/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
